// Responsive "cover" layout. The scene is authored at 640x448 (landscape). On
// tall/narrow devices a plain letterbox would shrink it into a small strip with
// big top/bottom bars. Instead we scale to FILL the height and crop the side
// decoration — but never past SAFE_W, so every spawn point (windows/door, all
// within the centred safe band) stays visible. `view` is the visible slice of
// the 640x448 buffer; the HUD positions itself against it so score/time/ammo
// never fall into the cropped-off sides.

export const BW = 640;
export const BH = 448;

// True when the primary pointer is touch (phones/tablets) — used to hide the
// mouse crosshair, which is meaningless when you tap to shoot.
export const IS_TOUCH = typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia("(pointer: coarse)").matches;
export const SAFE_W = 460; // guaranteed-visible buffer width (spawn span + margin), centred

export const view = { left: 0, top: 0, right: BW, bottom: BH };

// HUD scale factor (score/time/ammo/boss bar). 1 = original size.
export const HUD_SCALE = 1;

// Returns the stage scale (buffer px -> CSS px) and updates `view` in place.
export function computeView(vw: number, vh: number): number {
  // fill the height, but clamp so at least SAFE_W of the width stays visible
  const scale = Math.min(vh / BH, vw / SAFE_W);
  const visW = Math.min(BW, vw / scale);
  const visH = Math.min(BH, vh / scale);
  view.left = (BW - visW) / 2;
  view.right = BW - view.left;
  view.top = (BH - visH) / 2;
  view.bottom = BH - view.top;
  return scale;
}
